import { EnquiryAttribution } from '@theme/enquiry-attribution';
import { replayQueue } from '@theme/enquiry-transport';

/**
 * Runs on every page, not just enquiry pages.
 *
 * Attribution has to be captured at landing. Someone arrives on a collection page from a paid ad,
 * browses for ten minutes, then reaches the enquiry form — by which point the campaign parameters
 * are long gone from the URL. Capturing only where the form lives is exactly why three quarters of
 * form visits are currently recorded as "direct".
 *
 * Replaying the failed-submission queue here too means a lead that could not be delivered on
 * Tuesday gets another chance the next time that person opens any page on the site.
 */

EnquiryAttribution.capture();

replayQueue();

// A visitor who submitted while offline, or on a train, gets retried the moment they reconnect.
window.addEventListener('online', () => {
  replayQueue();
});
